import { render, staticRenderFns } from "./NotificationActionIcon.vue?vue&type=template&id=b3d97f08&scoped=true"
import script from "./NotificationActionIcon.vue?vue&type=script&lang=js"
export * from "./NotificationActionIcon.vue?vue&type=script&lang=js"
import style0 from "./NotificationActionIcon.vue?vue&type=style&index=0&id=b3d97f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d97f08",
  null
  
)

export default component.exports